const BASE = 'BOARD_',
BASE_CONNECTION = BASE + 'CONNECTION_',
BASE_DRAG = BASE + 'DRAG_',
BASE_NODE = BASE + 'NODE_';

/**
 * @name CONNECTION_ADD
 * @constant
 * @string
 * @description Used to add a connection between two nodes
 */
export const CONNECTION_ADD = BASE_CONNECTION + 'ADD';

/**
 * @name CONNECTION_REMOVE
 * @constant
 * @string
 * @description Used to remove a connection between two nodes
 */
export const CONNECTION_REMOVE = BASE_CONNECTION + 'REMOVE';

/**
 * @name CURRENT_NODE
 * @constant
 * @string
 * @description Used to set the context to a specific node
 */
export const CURRENT_NODE = BASE + 'CURRENT_NODE';

/**
 * @name DRAG_BOARD
 * @constant
 * @string
 * @description Used to tell the app to drag the view of the board
 */
export const DRAG_BOARD = BASE_DRAG + 'BOARD';

/**
 * @name DRAG_NODE
 * @constant
 * @string
 * @description Used to tell the app to drag a node on the board
 */
export const DRAG_NODE = BASE_DRAG + 'NODE';

/**
 * @name DRAG_SET
 * @constant
 * @string
 * @description Used to tell the app to drag a node on the board
 */
export const DRAG_SET = BASE_DRAG + 'SET';

/**
 * @name FORK
 * @constant
 * @string
 * @description Used to fork an existing NFT
 */
export const FORK = BASE + 'FORK';

/**
 * @name NEW
 * @constant
 * @string
 * @description Used to tell the app to clear the current board
 */
export const NEW = BASE + 'NEW';

/**
 * @name NODE_ADD
 * @constant
 * @string
 * @description Used to create a new node
 */
export const NODE_ADD = BASE_NODE + 'ADD';

/**
 * @name NODE_DELETE
 * @constant
 * @string
 * @description Used to delete a node
 */
export const NODE_DELETE = BASE_NODE + 'DELETE';

/**
 * @name NODE_EVIDENCE
 * @constant
 * @string
 * @description Used to add/edit/remove evidence from an existing node
 */
export const NODE_EVIDENCE = BASE_NODE + 'EVIDENCE';

/**
 * @name NODE_MODIFY
 * @constant
 * @string
 * @description Used to modify an existing node
 */
export const NODE_MODIFY = BASE_NODE + 'MODIFY';

/**
 * @name NODE_MENU
 * @constant
 * @string
 * @description Used to open a context menu for a node
 */
export const NODE_MENU = BASE + 'NODE_MENU';

/**
 * @name OPEN
 * @constant
 * @string
 * @description Used to tell the app to open a locally saved current board
 */
export const OPEN = BASE + 'OPEN';

/**
 * @name RESIZE
 * @constant
 * @string
 * @description Used to tell the app that the dimensions of the board have resized
 */
export const RESIZE = BASE + 'RESIZE';

/**
 * @name SAVE
 * @constant
 * @string
 * @description Used to tell the app to save the current board
 */
export const SAVE = BASE + 'SAVE';

/**
 * @name SET_NAME
 * @constant
 * @string
 * @description Used to set the name of a board
 */
export const SET_NAME = BASE + 'SET_NAME';

/**
 * @name ZOOM
 * @constant
 * @string
 * @description Used to zoom in/out the board
 */
export const ZOOM = BASE + 'ZOOM';